import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { PlotProvince, RiskAdversity, RiskAnalysis, RiskPlot } from "./models/RiskAnalysesModel";

export default class EmergencyAnalysesVuexModule extends AbacoVuexModule {
    @State({ default: null }) dummy!: boolean;
    @State({ default: false }) loadingPlots!: boolean;
    @State({ default: [] }) riskAnalyses!: RiskAnalysis[];
    @State({ default: null }) curRisk!: RiskAnalysis;
    @State({ default: [] }) riskPlots!: RiskPlot[];
    @State({ default: [] }) plotsFilteredByCrop!: Plot[];
    @State({ default: [] }) selectedPlots!: Plot[];
    @State({ default: [] }) lastRiskAnalyses!: Record<string, RiskAnalysis>;
    @State({ default: [] }) plotProvinces!: PlotProvince[];
    @State({ default: null }) adversitiesRisks!: RiskAdversity[] | null;
}
